import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import Header from "../Header";
import MicRecorder from "mic-recorder-to-mp3";
import moment from "moment";
import MessagePanel from "../components/MessagePanel";

const Mp3Recorder = new MicRecorder({ bitRate: 64 });

export default function NewReferral({ onLogin }) {
  const navigate = useNavigate();
  const [currentTheme, setCurrentTheme] = useState("dark");
  const [currentScreen, setCurrentScreen] = useState("referral");
  // const [loginData, setLoginData] = useState({ user: "", pass: "" });

  const [isRecording, setIsRecording] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [seconds, setSeconds] = useState(0);
  // const [referralId, setReferralId] = useState("");

  const [referralDate, setReferralDate] = useState({});
  const [transcriptionResult, setTranscriptionResult] = useState("");
  const [messageConfig, setMessageConfig] = useState({
    show: false,
    type: "success",
    title: "",
    message: "",
    subMessage: "",
    callback: null,
  });

  const [clock, setClock] = useState("12:00");
  const timerIntervalRef = useRef(null);

  const startNew = async () => {
    setReferralDate({
      PatientId: null,
      EntryDateTime: null,
      PatientName: null,
      Age: null,
      Gender: null,
      PatientPhoneNumber: null,
      SymptomsAndSigns: null,
      ReferredToFacilityName: null,
      ReferredToFacilityCode: null,
      ReferrerName: null,
      ReferrerDesignation: null,
      ReferrerOrganization: null,
      FacilityCode: null,
      ReferrerPhoneNumber: null,
      ExaminationFindings: null,
      InvestigationsWithResults: null,
      Diagnosis: null,
      Icd10Code: null,
      TreatmentGiven: null,
      DrugHypersensitivity: null,
      ReasonForReferral: null,
      AdviceToPatient: null,
      Transport: null,
      Comments: null,
      Timestamp: null,
      SpokenText: null,
      ExtractedJson: null,
    });
    setTranscriptionResult("");
    // 🎤 Start Recording
    await Mp3Recorder.start();
  };
  // Update clock every second
  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      setClock(
        now.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
      );
    };
    updateClock();
    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval);
  }, []);

  // Timer for recording
  useEffect(() => {
    if (isRecording) {
      timerIntervalRef.current = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);
    } else {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
      }
    }
    return () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
      }
    };
  }, [isRecording]);

  // const toggleTheme = () => {
  //   setCurrentTheme((prev) => (prev === "dark" ? "light" : "dark"));
  // };

  const showScreen = (screenId) => {
    setCurrentScreen(screenId);
  };
  
    const recordStop = (screenId) => {
      setIsRecording(false);
      setSeconds(0);
  };

  const generateReferralID = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let result = "";
    for (let i = 0; i < 8; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  const toggleMic = () => {
    if (!isRecording) {
      startNew();
      console.log("Starting recording...");
      setIsRecording(true);
      setSeconds(0);
    } else {
      console.log("Stopping recording...");
      recordStop();
      stopRecording();
    }
  };

  // 🛑 Stop Recording
  const stopRecording = async () => {
    setIsProcessing(true);
    try {
      const newPatientId = generateReferralID();

      let newData = { ...referralDate };
      newData.PatientId = newPatientId;
      newData.EntryDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
      newData.Timestamp = moment().format("YYYY-MM-DD HH:mm:ss");

      const [buffer, blob] = await Mp3Recorder.stop().getMp3();
      const file = new File([blob], `${newPatientId}.mp3`, {
        type: "audio/mpeg",
      });

      const formData = new FormData();
      formData.append("audio", file);
      // formData.append("data", JSON.parse(newData));
      formData.append("data", JSON.stringify(newData));

      // Send MP3 to Node.js API

      // const audiouploadresponse = await fetch(
      //   `${process.env.REACT_APP_API_URL}/patientreferraluploadaudio`,
      //   {
      //     method: "POST",
      //     body: formData,
      //   }
      // );

        const audiouploadresponse = await fetch(
        `${process.env.REACT_APP_PYTHON_API_URL}/process-referral`,
        {
          method: "POST",
          body: formData,
        }
      );

      const audiouploadresult = await audiouploadresponse.json();
      console.log("Uploaded:", audiouploadresult);
      // let newFilePath = audiouploadresult.path;
      if (audiouploadresult.status) {
        setReferralDate(audiouploadresult.data);
        setTranscriptionResult(
          audiouploadresult.transcription ??
            audiouploadresult.data?.SpokenText ??
            ""
        );
        setIsProcessing(false);
        showScreen("details");
      } else {
        // alert("Audio upload failed. Please try again.");
        setIsProcessing(false);
        setMessageConfig({
          show: true,
          type: "error",
          title: "Upload Failed",
          message:
            audiouploadresult.message ||
            "Audio upload/transcription failed. Please try again.",
          subMessage: "",
        });
      }
    } catch (err) {
      console.error("Stop failed:", err);
      setIsProcessing(false);

          setMessageConfig({
          show: true,
          type: "error",
          title: "Upload Failed",
          message: "Audio upload/transcription failed. Please try again.",
          subMessage: "",
        });


    }
  };

  const formatTimer = (totalSeconds) => {
    const mins = Math.floor(totalSeconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (totalSeconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  };

  return (
    <div data-theme={currentTheme}>
      <div className="fixed inset-0 w-full h-full pointer-events-none z-0 transition-colors duration-500">
        <div
          className="absolute top-[-10%] left-[-10%] w-96 h-96 rounded-full blur-[100px]"
          style={{ background: "var(--bg-grad-1)" }}
        ></div>
        <div
          className="absolute bottom-[-10%] right-[-10%] w-96 h-96 rounded-full blur-[100px]"
          style={{ background: "var(--bg-grad-2)" }}
        ></div>
      </div>

      <div
        id="app"
        className="relative z-10 w-full max-w-md mx-auto flex flex-col shadow-2xl transition-all duration-500 overflow-hidden"
        style={{
          height: "100dvh",
          background: "rgba(var(--bg-app), 0.8)",
          borderLeft: "1px solid var(--glass-border)",
          borderRight: "1px solid var(--glass-border)",
        }}
      >
        {/* Referral Screen */}
        {currentScreen === "referral" && (
          <div
            className="absolute inset-0 flex flex-col z-40"
            style={{ backgroundColor: "var(--bg-app)" }}
          >
           
            <Header BackTo={"/home"} />

            {/* Processing Loader Overlay */}
            {isProcessing && (
              <div className="absolute inset-0 bg-black/60 backdrop-blur-sm z-50 flex flex-col items-center justify-center">
                <div className="relative">
                  <div className="w-20 h-20 border-4 border-cyan-500/30 border-t-cyan-500 rounded-full animate-spin"></div>
                  <div className="absolute inset-0 w-20 h-20 border-4 border-purple-500/30 border-t-purple-500 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
                </div>
                <p className="mt-6 text-cyan-400 font-semibold text-lg animate-pulse">Processing Audio...</p>
                <p className="mt-2 text-muted text-sm">Transcribing audio</p>
              </div>
            )}

            <div className="flex-1 flex flex-col items-center justify-center relative z-10 w-full">
              {!isRecording && (
                <div className="text-muted text-sm tracking-widest uppercase animate-pulse">
                  Tap mic to start
                </div>
              )}

              {isRecording && (
                <div className="relative w-full h-80 flex items-center justify-center">
                  <div className="orb-container">
                    <div className="tech-ring-1"></div>
                    <div className="tech-ring-2"></div>
                    <div className="fluid-blob blob-2"></div>
                    <div className="fluid-blob blob-1"></div>
                    <div className="fluid-blob blob-3"></div>
                  </div>
                  <div className="absolute bottom-10 font-mono text-accent text-xs tracking-widest z-50 animate-pulse">
                    LISTENING...
                  </div>
                </div>
              )}
            </div>

            <div className="pb-12 flex flex-col items-center z-20 shrink-0">
              <div className="font-mono text-5xl font-light mb-8 text-muted">
                {formatTimer(seconds)}
              </div>
              <button
                onClick={toggleMic}
                className={`relative w-20 h-20 rounded-full shadow-xl flex items-center justify-center transition-all active:scale-90 hover:scale-105 cursor-pointer z-50 ${
                  isRecording ? "mic-ring-effect" : ""
                }`}
                style={{
                  backgroundColor: isRecording
                    ? "#ef4444"
                    : "var(--text-accent)",
                }}
              >
                {!isRecording ? (
                  <svg
                    className="w-10 h-10 text-white"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z" />
                    <path d="M19 10v2a7 7 0 01-14 0v-2h-2v2a9 9 0 008 8.94V23h2v-2.06A9 9 0 0021 12v-2h-2z" />
                  </svg>
                ) : (
                  <svg
                    className="w-10 h-10 text-white"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <rect x="7" y="7" width="10" height="10" rx="1" />
                  </svg>
                )}
              </button>

              <p
                className={`mt-4 text-xs uppercase tracking-widest ${
                  isRecording ? "text-red-500" : "text-muted"
                }`}
              >
                {isRecording ? "STOP" : "Ready"}
              </p>
            </div>
          </div>
        )}

        {/* Details Screen */}
        {currentScreen === "details" && (
          <div
            className="absolute inset-0 flex flex-col z-50"
            style={{ backgroundColor: "var(--bg-app)" }}
          >
            <div className="p-6 pt-10 flex justify-between items-center shrink-0 glass z-20">
              <h2 className="text-xl font-bold text-accent">
                Referral Details
              </h2>
            </div>

            <div className="flex-1 overflow-y-auto p-6 pb-24 hide-scroll">
              <div className="space-y-6 animate-enter">
                <div className="flex flex-col gap-2">
                  <p className="text-center text-xs font-mono text-muted uppercase tracking-widest">
                    {referralDate.EntryDateTime
                      ? new Date(referralDate.EntryDateTime).toLocaleString(
                          "en-US",
                          {
                            weekday: "long",
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                          }
                        )
                      : ""}
                  </p>
                  <div
                    className="w-full p-4 rounded-2xl border text-center flex flex-col items-center justify-center relative overflow-hidden"
                    style={{
                      backgroundColor: "var(--id-bg)",
                      borderColor: "var(--id-border)",
                    }}
                  >
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent opacity-50"></div>
                    <p className="text-[10px] uppercase tracking-[0.2em] text-muted mb-1">
                      Referral Generated ID
                    </p>
                    <h1 className="text-4xl font-mono font-bold tracking-widest text-accent drop-shadow-sm">
                      {referralDate.PatientId ? referralDate.PatientId : ""}
                    </h1>
                  </div>
                </div>

                {/* Transcription - below Referral ID */}
                {transcriptionResult != null && transcriptionResult !== "" && (
                  <div className="flex flex-col gap-2">
                    <label className="input-label">Transcription</label>
                    <div
                      className="w-full p-4 rounded-2xl border overflow-hidden"
                      style={{
                        backgroundColor: "var(--id-bg)",
                        borderColor: "var(--id-border)",
                        minHeight: "2.5rem",
                      }}
                    >
                      <pre
                        className="m-0 text-sm whitespace-pre-wrap break-words font-sans text-left"
                        style={{
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {transcriptionResult}
                      </pre>
                    </div>
                  </div>
                )}

              </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 p-4 glass z-20">
              <button
                onClick={() => showScreen("referral")}
                className="w-full py-3 rounded-xl bg-cyan-600 text-white font-bold shadow-lg hover:bg-cyan-500 transition-colors"
              >
                Record another
              </button>
            </div>
          </div>
        )}

        {/* Message Panel */}
        <MessagePanel
          show={messageConfig.show}
          type={messageConfig.type}
          title={messageConfig.title}
          message={messageConfig.message}
          subMessage={messageConfig.subMessage}
          onClose={() => setMessageConfig({ ...messageConfig, show: false })}
          onCallback={messageConfig.callback}
          autoClose={true}
          duration={3000}
        />
      </div>
    </div>
  );
}
